import { render } from "./ObjectCopyFields.vue?vue&type=template&id=6d179632"
import script from "./ObjectCopyFields.vue?vue&type=script&lang=js"
export * from "./ObjectCopyFields.vue?vue&type=script&lang=js"

import "./ObjectCopyFields.vue?vue&type=style&index=0&id=6d179632&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.17.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__